import React from "react";
import TableRow from "./tablerow";

function TableBody(props) {
  const tableData = props.data.map(rowData => (
    <TableRow accesors={props.accesors} data={rowData} />
  ));
  return <tbody>{tableData}</tbody>;
}

export default TableBody;
